import { StrictMode, createElement } from "react";
import { createRoot } from "react-dom/client";
import { createVybeApp, PlatformProvider } from "@vybe/ui";
import { AppRoutes } from "@vybe/ui/app/routes";
import { webPlatformConfig } from "./src/platform-config";
import "@vybe/ui/globals.css";

const VybeApp = createVybeApp(<AppRoutes />);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PlatformProvider config={webPlatformConfig}>
      {createElement(VybeApp)}
    </PlatformProvider>
  </StrictMode>,
);
